import { APP_CONSTANTS } from 'src/app/constants/constants';
import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-prospect-profile',
  templateUrl: './prospect-profile.component.html',
  styleUrls: ['./prospect-profile.component.scss'],
})
export class ProspectProfileComponent implements OnInit {
  APP_CONSTANTS = APP_CONSTANTS;

  @Input() prospect_data: any;

  constructor() {}

  ngOnInit(): void {}

  selected_tab: any = "Basic Information";
}
